export default "__VITE_ASSET__BkuBQBtn__ 584w";